module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/return-policy/return-policy-edit/return-policy-edit.component.css
// module id = ./src/app/return-policy/return-policy-edit/return-policy-edit.component.css
// module chunks = main